import { PublicClientApplication } from '@azure/msal-browser';
import React from 'react';

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: process.env.REACT_APP_AZURE_AUTHORITY,
    redirectUri: process.env.REACT_APP_REDIRECT_URI
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

export const login = async () => {

  console.log("fired login", msalInstance)
  const loginRequest = {
    scopes: ['user.read', 'openid', 'profile'], // Define the required permissions
  };

  try {
    await msalInstance.initialize();
    const authResponse = await msalInstance.loginPopup(loginRequest);
    console.log('cooked up', authResponse);
    
    return authResponse;
  } catch (error) {
    // Handle login error
  }
};

export const logout = () => {
  msalInstance.logout();
};

class HandleToken extends React.Component {
  render() {
    console.log('token acquired', this);
    return;
  }
}

export default HandleToken;